/* eslint-disable import/no-unresolved */
import Card from "pages/_components/Card/Card";
import CardContainer from "pages/_components/Card/CardContainer";
import Container from "pages/_components/Container";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import I18n from "pages/_components/I18n";
import InfoTag from "pages/_components/InfoTag";
import Spinner from "pages/_components/Spinner";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { selectors } from "reducers/checks";
import { selectors as sessionSelectors } from "reducers/session";
import * as accountUtils from "util/accounts";
import * as checkUtils from "util/checks";
import { echeqShape } from "util/checks";
import * as i18n from "util/i18n";
import { addPrivateShellScrollListener, readPrivateShellScrollTop } from "util/privateShellScrollTarget";
import { isUxDashboardImprovementsEnabled, buildEcheqMassiveBatchDetailLocation } from "util/v3ShellLayoutSync";
import { V3_SCROLL_ROOT_ID } from "v3/constants";

const FORM_ID = "echeq";

class BatchList extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        batchList: arrayOf(echeqShape).isRequired,
        loggedUser: shape({
            userId: string.isRequired,
        }).isRequired,
        isDesktop: bool.isRequired,
        hasMoreData: bool.isRequired,
        fetchNextTransactions: func.isRequired,
        accounts: arrayOf(
            shape({
                cbu: string.isRequired,
            }),
        ).isRequired,
    };

    state = {
        isAtTop: false,
    };

    componentDidMount() {
        const { dispatch, accounts, loggedUser } = this.props;

        if (!accounts.length > 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }
        this.syncPrivateShellScrollListener();
    }

    componentDidUpdate(prevProps) {
        const { isDesktop } = this.props;
        if (prevProps.isDesktop !== isDesktop) {
            this.syncPrivateShellScrollListener();
        }
    }

    componentWillUnmount() {
        if (this.removePrivateShellScrollListener) {
            this.removePrivateShellScrollListener();
            this.removePrivateShellScrollListener = null;
        }
    }

    syncPrivateShellScrollListener = () => {
        const { isDesktop } = this.props;
        if (this.removePrivateShellScrollListener) {
            this.removePrivateShellScrollListener();
            this.removePrivateShellScrollListener = null;
        }
        if (!isDesktop) {
            this.removePrivateShellScrollListener = addPrivateShellScrollListener(this.handleScrollCheck);
        }
    };

    handleScrollCheck = () => {
        const scrollTopPosition = readPrivateShellScrollTop();

        // Artificio para evitar recarga de informacion al inicio de la pantalla
        const currentlyAtTop = scrollTopPosition < 5;
        const { isAtTop } = this.state;
        if (currentlyAtTop !== isAtTop) {
            this.setState({ isAtTop: currentlyAtTop });
        }
    };

    cardsBatchEcheqs = () => {
        const { batchList, accounts } = this.props;

        return batchList.map((object) => {
            const accountOrigin = accounts.find((account) => object.cbuOrigin === account?.cbu);
            const accountName = accountOrigin?.number ? accountUtils.getAccountDescription(accountOrigin) : "-";
            return (
                <CardContainer
                    key={object.idBatch}
                    renderAs={Link}
                    to={
                        object?.transactionId
                            ? buildEcheqMassiveBatchDetailLocation(
                                  object.transactionId,
                                  typeof window !== "undefined" && window.location?.pathname
                                      ? window.location.pathname
                                      : "/echeqs",
                              )
                            : "#!"
                    }>
                    <Card
                        title={
                            <div className="echeqs__cards-title">
                                <div
                                    className={
                                        object.reference === ""
                                            ? "d-flex echeqs__batch-info no-separator"
                                            : "d-flex echeqs__batch-info"
                                    }>
                                    <I18n
                                        id={`${FORM_ID}.batch.table.header.processDate`}
                                        componentProps={{ className: "echeqs__emittedDate" }}
                                    />
                                    <FormattedDate showTime={false} date={object.processDate} />
                                </div>
                                <div className="d-flex echeqs__batch-info-secondary">
                                    {object.reference !== "" && (
                                        <I18n
                                            id={`${FORM_ID}.batch.table.header.reference`}
                                            componentProps={{ className: "echeqs__paymentDate" }}
                                        />
                                    )}
                                    <span>{object.reference}</span>
                                </div>
                            </div>
                        }
                        content={
                            <div className="echeqs__cards-content">
                                <I18n
                                    component="span"
                                    id={`${FORM_ID}.batch.table.header.batchId`}
                                    componentProps={{ className: "echeqs__batchId" }}
                                />
                                <span>{object.idBatch}</span>
                                <div className="echeqs__type">
                                    <I18n
                                        id={`${FORM_ID}.batch.table.header.echeqQuantity`}
                                        componentProps={{ className: "echeqs__quantity" }}
                                    />
                                    <span>{object.quantity}</span>
                                </div>
                            </div>
                        }
                        bottom={
                            <div className="echeqs__cards-bottom">
                                <div className="echeqs__batch-emitted">
                                    <I18n
                                        id={`${FORM_ID}.batch.table.header.emitAccount`}
                                        componentProps={{ className: "echeqs__received-title" }}
                                    />
                                    <span>{accountName}</span>
                                </div>
                            </div>
                        }
                        rightContent={
                            <div className="echeqs__cards-rightContent">
                                <div className="echeqs__cards-right-info">
                                    <div className="echeqs__cards-amount">
                                        <I18n
                                            id={`${FORM_ID}.batch.table.header.totalAmount`}
                                            componentProps={{ className: "echeqs__total-amount-label" }}
                                        />
                                        <FormattedAmount currency={object.currency} quantity={object.totalAmount} />
                                    </div>
                                    <InfoTag
                                        type="info"
                                        message={i18n.get(`echeq.batch.status.${object.status.toLowerCase()}`)}
                                        tagBackground={checkUtils.statusTagColorBatch(object.status)}
                                        moreStyles={{
                                            color: "black",
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    />
                </CardContainer>
            );
        });
    };

    echeqsListMobile = (echeq) => {
        const { accounts, isDesktop } = this.props;

        const { idBatch, transactionId, status, cbuOrigin, reference, processDate, quantity, totalAmount } = echeq;
        const accountOrigin = accounts.find((account) => cbuOrigin === account?.cbu);
        const accountName = accountOrigin?.number ? accountUtils.getAccountDescription(accountOrigin) : "-";

        return (
            <CardContainer
                renderAs={Link}
                to={
                    transactionId
                        ? buildEcheqMassiveBatchDetailLocation(
                              transactionId,
                              typeof window !== "undefined" && window.location?.pathname
                                  ? window.location.pathname
                                  : "/echeqs",
                          )
                        : "#!"
                }
                className="px-3">
                <Card
                    hrClass="ml-2"
                    title={
                        <div className="d-flex w-100 space-between echeqs__cards-title">
                            <div className="d-flex w-100">
                                <I18n
                                    id={`${FORM_ID}.batch.table.header.batchId`}
                                    componentProps={{ className: "ml-2 echeq__info" }}
                                />
                                <span className="echeq__data">{idBatch}</span>
                            </div>
                        </div>
                    }
                    content={
                        <div>
                            <hr className="ml-2" />
                            <div className="echeqs__cards-content">
                                <div className="d-flex space-between w-100 pb-1 align-items-center">
                                    <I18n id="echeqs.status.label" componentProps={{ className: "ml-2 echeq__info" }} />
                                    <InfoTag
                                        type="info"
                                        message={i18n.get(`echeq.batch.status.${status.toLowerCase()}`)}
                                        tagBackground={checkUtils.statusTagColorBatch(status)}
                                        tagClass="d-flex px-2 ml-2 my-0 mr-0"
                                        moreStyles={{
                                            color: "black",
                                        }}
                                    />
                                </div>
                                <div className="d-flex space-between w-100">
                                    <I18n
                                        id={`${FORM_ID}.batch.table.header.processDate`}
                                        componentProps={{ className: "ml-2 echeq__info" }}
                                    />
                                    <FormattedDate date={processDate} />
                                </div>
                                <div className="d-flex space-between w-100">
                                    <I18n
                                        id={`${FORM_ID}.batch.table.header.reference`}
                                        componentProps={{ className: "ml-2 echeq__info" }}
                                    />
                                    <span className="echeq__data">{reference}</span>
                                </div>
                                <div className="d-flex space-between w-100 pt-1">
                                    <I18n
                                        id={`${FORM_ID}.batch.table.header.echeqQuantity`}
                                        componentProps={{ className: "ml-2 echeq__info" }}
                                    />
                                    <span className="echeq__data">{quantity}</span>
                                </div>
                                <div className="d-flex space-between w-100 pt-1">
                                    <I18n
                                        id={`${FORM_ID}.batch.table.header.emitAccount`}
                                        componentProps={{ className: "ml-2 echeq__info" }}
                                    />
                                    <span className="echeq__data">{accountName}</span>
                                </div>
                            </div>
                        </div>
                    }
                    rightContent={
                        <div className="echeqs__cards-rightContent">
                            <div className="echeqs__cards-amount">
                                <I18n
                                    id={`${FORM_ID}.batch.table.header.totalAmount`}
                                    componentProps={{ className: "echeqs__total-amount-label" }}
                                />
                                <FormattedAmount
                                    currency={accountOrigin?.currency}
                                    quantity={totalAmount}
                                    notBold={isDesktop}
                                    className="echeq__data"
                                />
                            </div>
                        </div>
                    }
                />
            </CardContainer>
        );
    };

    render() {
        const { batchList, isDesktop, hasMoreData, fetchNextTransactions } = this.props;
        const endOfListItem = (
            <div className="table-row table-end mb-5" key="noMoreTransactions">
                <I18n id="echeqs.noMoreEcheqs" />
            </div>
        );
        const { isAtTop } = this.state;
        if (!isDesktop) {
            return (
                <>
                    <InfiniteScroll
                        dataLength={batchList.length}
                        next={() => {
                            if (!isAtTop) {
                                fetchNextTransactions();
                            }
                        }}
                        hasMore={hasMoreData}
                        loader={<Spinner />}
                        initialLoad={false}
                        endMessage={endOfListItem}
                        scrollableTarget={isUxDashboardImprovementsEnabled() ? V3_SCROLL_ROOT_ID : undefined}>
                        {batchList.map((echeq) => this.echeqsListMobile(echeq))}
                    </InfiniteScroll>
                </>
            );
        }

        return (
            <Container className="flex-grow" rowClassName="">
                <Col xs={12} className="px-0">
                    <div
                        style={{ borderSpacing: "0px 2px", width: "100%" }}
                        ref={(tableRef) => {
                            this.child = tableRef;
                        }}>
                        <Container className="flex-grow align-items-center" gridClassName="scrolleable form-content">
                            {this.cardsBatchEcheqs()}
                        </Container>
                    </div>
                </Col>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    batchList: selectors.getEcheqsList(state),
    hasMoreData: selectors.getHasMoreData(state),
    accounts: accountsSelectors.getAccounts(state),
    loggedUser: sessionSelectors.getUser(state),
});

export default connect(mapStateToProps)(BatchList);
